import * as React from 'react';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { useTheme } from 'styled-components';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import useIsWiderThan from '@/hooks/useIsWiderThan';

type Props = {
    className?: string;
    sellerId: number;
};

const JASPER52_ID = 5584;

const GetAnswersModalFooter = ({ className, sellerId }: Props) => {
    const {
        breakpoints: { tabletNarrowWidthNum },
    } = useTheme();
    const isMobile = !useIsWiderThan(tabletNarrowWidthNum);

    return sellerId === JASPER52_ID ? (
        <BodySecondary
            className={className}
            color="secondary"
        >
            <FormattedMessage
                id="sharedModal.footerJ52"
                values={{
                    link: (
                        <Link
                            key="shared-modal-footer-j52-link"
                            rel="noopener"
                            target="_blank"
                            to="https://support.jasper52.com/"
                        >
                            <FormattedMessage id="sharedModal.footerLink" />
                        </Link>
                    ),
                }}
            />
        </BodySecondary>
    ) : (
        <BodySecondary
            className={className}
            color="secondary"
        >
            <FormattedMessage
                id="sharedModal.footer"
                values={{
                    link: (
                        <>
                            {isMobile ? <br /> : ''}
                            <Link
                                key="shared-modal-footer-link"
                                rel="noopener"
                                target="_blank"
                                to="https://help.liveauctioneers.com/"
                            >
                                <FormattedMessage id="sharedModal.footerLink" />
                            </Link>
                        </>
                    ),
                }}
            />
            &nbsp;
        </BodySecondary>
    );
};

export default GetAnswersModalFooter;
